import { normalize, schema } from 'normalizr';

export const entity = 'brand';
export const entitySchema = new schema.Entity(entity);
export const normalizer = (result) => normalize(result, entitySchema);
export const listNormalizer = (result) => normalize(result, [entitySchema]);
